<template>
  <div
    class="header"
    v-if="
      (!state.badfish &&
        !webChatFlag &&
        !aliFlag &&
        !xzApp &&
        !state.isTalentApp &&
        !state.isLark &&
        !state.isalipay &&
        !istoutiao)||showHeader
    "
  >
    <div class="headIcon_wrap">
      <router-link v-if="showHome && isShowPageTitle!== 'aviationButler' " to="/" tag="div"></router-link>
      <div class="back iconfont" v-if="!showHome && isShowPageTitle!== 'aviationButler' " @click="back">&#xe742;</div>
      <div v-if="indexShow" class="indexTitle">酒店之外 就住小猪</div>
    </div>
    <div class="title">{{ topTitle }}</div>
    <span
      class="iconfont share"      
      @click="toggleShare(shareData)"
      v-if="showShare && !state.isaliPay && !ttMp"
      >&#xe775;</span
    >
    <div class="log_reg" v-if="showList && !ttMp" ref="listShow">
      <div class="icon iconfont" @click="toggleMenu">&#xe807;</div>
      <transition name="slide-fade">
        <div v-show="willShow" class="logreg_ul">
          <i class="closeBtn iconfont" @click="hideSide">&#xe737;</i>
          <ul v-if="hadLog">
            <router-link v-if="indexType" tag="li" :to="{ path: '/' }">
              <i class="iconfont">&#xe7fa;</i>
              <span>首页</span>
            </router-link>
            <li v-if="messageType" @click="goChat">
              <i class="iconfont">&#xe803;</i>
              <span>消息</span>
              <i class="redDot" v-if="messageCount"></i>
            </li>
            <router-link
              v-if="orderType"
              tag="li"
              :to="{ path: '/order/orderList/' }"
            >
              <i class="iconfont">&#xe7f9;</i>
              <span>订单</span>
              <i class="redDot" v-if="orderCount"></i>
            </router-link>
            <router-link v-if="myType" tag="li" :to="{ path: '/myInfo' }">
              <i class="iconfont">&#xe801;</i>
              <span>个人中心</span>
            </router-link>
          </ul>
          <ul v-else>
            <router-link tag="li" :to="{ path: '/login' }">
              <i class="iconfont">&#xe806;</i>
              <span>登录</span>
            </router-link>
            <router-link tag="li" :to="{ path: '/register' }">
              <i class="iconfont">&#xe805;</i>
              <span>注册</span>
            </router-link>
            <router-link v-if="indexType" tag="li" :to="{ path: '/' }">
              <i class="iconfont">&#xe7fa;</i>
              <span>首页</span>
            </router-link>
          </ul>
          <i class="home"></i>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div class="menu-mask" v-show="willShow" @click="hideSide"></div>
    </transition>
    <share :shareData="shareData" ref="webshare"></share>
  </div>
</template>
<script>
// showHome : 左侧button true为回到首页icon  false为返回上一页
// topTitle : 标题
// showList : 右侧列表区域是否展示
// lastPage : 指定返回页面
import share from "./share";
import getUa from "../../utils/getUa";
import { navCount } from "../../service/getData";
import { Indicator } from "mint-ui";
export default {
  components: {
    share
  },
  data() {
    return {
      isShowPageTitle:'show',
      willShow: false,
      isVisible: false,
      state: getUa.userAgent,
      xzApp: getUa.userAgent.isxzapp,
      ttMp: getUa.userAgent.istoutiaomp || getUa.userAgent.isLark,
      indexType: true,
      messageType: true,
      orderType: true,
      myType: true,
      messageCount: false,
      webChatFlag: false,
      aliFlag: false,
      istoutiao: false,
      orderCount: false,
    };
  },
  props: {
    showHome: Boolean,
    topTitle: String,
    showList: Boolean,
    lastPage: String,
    showShare: Boolean,
    indexShow: Boolean,
    shareData: Object,
    pageType: Number,
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hadLog() {
      return !!this.getCookie("userInfo") || !!this.getStore("userInfo")
    },
    userInfo() {
      const userInfo = this.getCookie("userInfo");
      return userInfo ? JSON.parse(userInfo) : {};
    }
  },
  methods: {
    back() {
      this.removeStore("shareInfos");
      if (this.lastPage) {
        this.$router.push({ name: this.lastPage });
      } else {
        Indicator.close();
        this.$router.back(-1);
      }
    },
    goChat() {
      localStorage.removeItem("chatIndex");
      this.$router.push("/chatList");
    },
    toggleMenu() {
      this.willShow = !this.willShow;
      if (this.willShow) {
        this.removeStore("shareInfos");
      } else {
        this.setStore("shareInfos", this.shareData);
      }
    },
    hideSide() {
      this.willShow = false;
      this.setStore("shareInfos", this.shareData);
    },
    toggleShare(datas) {
      this.$refs.webshare.toggle(datas);
    },
    setWchat() {
      const that = this;
      const shareInfo = that.shareData;
      setTimeout(function() {
        that.$refs.webshare.setWechatDefalutShare(
          shareInfo.objId,
          shareInfo.action
        );
      }, 10);
    },
    bodyScroll(event) {
      event.preventDefault();
    },
    getShareData() {
      this.$get(`${apiUrl}Wechat/JsConfig`, {}).then(res => {
        wx.config(res.content);
      });
    }
  },
  created() {
    // 判断是否在微信小程序中；
    this.judgeWebChat(this);
    // 判断支付宝小程序环境
    this.judgeAliChat(this);
    // 判断抖音
    this.judgeToutiao(this);
    const sourceCookie = this.getCookie("source")
    if (sourceCookie === 'aviationButler') {
      this.isShowPageTitle = 'aviationButler';
    }
  },
  mounted() {
    // 微信环境中 并且share元素可以获取到
    if (this.state.iswechat && this.showShare && this.$refs.webshare) {
      this.setWchat();
    }
    /*
            pageType :1 不显示首页
            pageType :2 不显示消息
            pageType :3 不显示订单
            pageType :4 不显示个人中心
        */
    if (this.pageType === 1) {
      this.indexType = false;
    } else if (this.pageType === 2) {
      this.messageType = false;
    } else if (this.pageType === 3) {
      this.orderType = false;
    } else if (this.pageType === 4) {
      this.myType = false;
    }
    if (this.hadLog) {
      this.$get(navCount, {
        userId: this.userInfo.userId,
        sessId: this.userInfo.sessId
      }).then(response => {
        if (response.status == 200) {
          if (response.content.unReadImMsgCount > 0) {
            this.messageCount = true;
          }
          if (response.content.changedBookOrderCount > 0) {
            this.orderCount = true;
          }
        }
      });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/header.vue